var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"odd text-center py-3 px-1 subtitle-2 d-flex flex-grow-0 justify-center align-center colorOddText--text",class:[
      {
        'transparent grey--text v-card--disabled':
          _vm.odd.odd_price < _vm.oddMin || _vm.odd.active != 1,
        'cursor-pointer oddActive':
          _vm.odd.odd_price > _vm.oddMin && _vm.odd.active === '1',
        colorOddSelectedTheme: _vm.oddSelected,
      },
      _vm.odd.odd_price > _vm.oddMin && _vm.odd.active == 1 ? _vm.oddClassAni : '',
    ],style:({
      'min-width': _vm.$vuetify.breakpoint.xsOnly ? '50px' : '56px',
      'min-height': _vm.$vuetify.breakpoint.xsOnly ? '50px' : '50px',
      margin: _vm.$vuetify.breakpoint.xsOnly
        ? '0 0 0 4px !important'
        : '0 4px 0 4px !important',
    }),on:{"click":function($event){return _vm.$selectOdd({
        id_event: _vm.event.id,
        id_odd: _vm.odd.id_odd,
        description: _vm.event.description,
        data: _vm.odd,
      })}}},[(_vm.odd.odd_price >= _vm.oddMin && _vm.odd.active == 1)?_c('span',{ref:_vm.odd.id_odd,class:_vm.odd.id_odd},[_vm._v("\n      "+_vm._s(_vm.roundedOddPrice || "")+"\n    ")]):_vm._e(),_c('v-icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.odd.odd_price < _vm.oddMin || _vm.odd.active != 1),expression:"odd.odd_price < oddMin || odd.active != 1"}],staticClass:"text--secondary",attrs:{"size":"14"}},[_vm._v("mdi-lock")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }